import {Component, Input, OnInit} from '@angular/core';
import {UserEventGridItemType,} from "@components";
import {
  CalendarViewType,
  Country,
  EventFilter,
  FindEventsRequest,
  LengthRange,
  Lookups,
  RegistrationStatus,
  Sport,
  UserEvent,
  PublicSearchFilter, isFilterActive
} from "@model";
import {ActivatedRoute, Router} from "@angular/router";
import {MyTraceyDataStore} from "@store";
import {MyTraceyTabs} from "../my-tracey.component";
import {EVENT_DETAILS, MY_TRACEY_ENTRY, PRIVATE_EVENT_CALENDAR_ROUTE} from "../../../../../app-routing.module";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LocalStorageService, UserEventsService} from "@services";
import {PagingComponent} from "../../../../../components/paging.component";
import {Observable} from "rxjs";

@Component({
  selector: 'app-my-tracey-upcoming',
  templateUrl: './my-tracey-upcoming.component.html',
  styleUrl: './my-tracey-upcoming.component.scss',
  standalone: false

})
export class MyTraceyUpcomingComponent extends PagingComponent<UserEvent> implements OnInit{

  @Input({required: true}) languages: Lookups[] = [];

  @Input() countries: Country[] = [];
  @Input() sports: Sport[] = [];
  @Input() upcomingEvents: UserEvent[] = [];
  @Input() pastEvents: UserEvent[] = [];

  searchFilter: PublicSearchFilter = {};
  lengthRanges: LengthRange[] = EventFilter.LENGTH_RANGES;
  currentLayout: CalendarViewType = CalendarViewType.LIST;
  isFilterActive: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,
              private store: MyTraceyDataStore, private modalService: NgbModal,
              private userEventsService: UserEventsService, private localStorageService: LocalStorageService
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showSpinner = false;
    this.handleExploreResult(this.upcomingEvents);
    this.updateLayout();
  }

  private updateLayout(): void {
    if (this.isMobile) {
      this.currentLayout = CalendarViewType.GRID;
    } else {
      this.currentLayout = CalendarViewType.LIST;
    }
  }


  goToEventDetailsPage(userEvent: UserEvent): void {
    if (userEvent.event?.id) {
      ///todo fix routes!!!!
      this.router.navigate(
          [PRIVATE_EVENT_CALENDAR_ROUTE, EVENT_DETAILS],
          {
            queryParams: {
              eventId: userEvent.event.id,
              isFinishedEvent: false
            }
          }
      );
    }
  }

  goToMyEntry(userEvent: UserEvent): void {
    const { race, event, competitor } = userEvent;
    if (!race?.id || !event?.id || !competitor?.id) {
      return;
    }
    this.router.navigate([MY_TRACEY_ENTRY], {
      queryParams: {
        competitorId: competitor.id }
    });
  }


  filterChanged(filter: PublicSearchFilter) {
    this.searchFilter = filter;
    this.isFilterActive = isFilterActive(filter);
    this.onExplore(false)
  }

  protected readonly MyTraceyTabs = MyTraceyTabs;
  protected readonly UserEventGridItemType = UserEventGridItemType;
  protected readonly RegistrationStatus = RegistrationStatus;
  protected readonly CalendarViewType = CalendarViewType;

  private createFilter(): FindEventsRequest {
    return FindEventsRequest.createEventPageFilter(this.page, {...this.searchFilter});
  }

  protected fetchPage(page: number): Observable<UserEvent[]> {
    return this.userEventsService.fetchUserUpcomingEvents(this.createFilter());
  }

  protected override afterSetItems(items: UserEvent[]): void {
    this.upcomingEvents = [...items];
  }

  goToEventCalendar() {
    this.router.navigate([PRIVATE_EVENT_CALENDAR_ROUTE]);
  }
}
